import { Flex, Text } from '@cellula/react';
import { primitiveColorTokens, tokens } from '@cellula/react-theme-patient';
import { BrandedIllustration, BrandedIllustrationType } from '@component/branded_illustration/branded_illustration.component';
import type { ReactNode } from 'react';
import styled from 'styled-components';

const Background = styled.div`
	display: flex;
	flex-grow: 1;
	flex-direction: column;
	align-items: center;
	background: ${tokens.color.bg.page};
	position: relative;
	overflow: auto;

	${tokens.breakpointQuery.small} {
		justify-content: center;

		&::before {
			display: block;
			content: '';
			display: flex;
			position: absolute;
			inset: 0;
			background: linear-gradient(150deg, transparent 26%, ${primitiveColorTokens.primary['300']});
			pointer-events: none;
			z-index: 0;
			opacity: 0.9;
		}
	}
`;

const OuterContainer = styled.div`
	display: flex;
	flex-grow: 1;
	flex-direction: column;
	position: relative;
	text-align: center;
	padding: ${tokens.spacing.x2};
	color: ${tokens.color.content.default};
	max-width: 460px;
	width: 100%;
	align-items: center;
	justify-content: center;
	gap: ${tokens.spacing.x4};

	${tokens.breakpointQuery.small} {
		flex-grow: 0;
		background: ${tokens.color.bg.surface};
		padding: ${tokens.spacing.x6};
		box-shadow: ${tokens.elevation.floating};
		border-radius: ${tokens.borderRadius.small};
		height: auto;
		overflow: hidden;
	}
`;

const TextContainer = styled(Flex)`
	max-width: 360px;
	width: 100%;
	gap: ${tokens.spacing.x1};
`;

const ButtonContainer = styled(Flex)`
	max-width: 296px;
	width: 100%;
	gap: ${tokens.spacing.x1};
`;

interface Props {
	title: ReactNode;
	description?: ReactNode;
	illustration?: BrandedIllustrationType;
	actions?: ReactNode;
}

export function ViewAppointmentState({ title, description, illustration, actions }: Props) {
	return (
		<Background>
			<OuterContainer>
				<Flex grow='1' justify='center'>
					<Flex gap={tokens.spacing.x4} align='center'>
						<TextContainer>
							<Text.h1 variant='headingMedium'>{title}</Text.h1>
							{description ? <Text variant='bodyRegular'>{description}</Text> : null}
						</TextContainer>
						{illustration ? (
							<div>
								<BrandedIllustration illustration={illustration} />
							</div>
						) : null}
					</Flex>
				</Flex>
				{actions ? <ButtonContainer>{actions}</ButtonContainer> : null}
			</OuterContainer>
		</Background>
	);
}
